import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { PersonLayout } from '../PersonLayout';
import { type ComboboxItem } from '@mantine/core';
import { type EmployeeDetailed } from '@/schemas/API/GET/employee/response';

const navigationOptions: ComboboxItem[] = [
  {
    label: 'Osobní údaje',
    value: 'personal',
  },
  {
    label: 'Doklady',
    value: 'documents',
  },
  {
    label: 'Vzdělání',
    value: 'education',
  },
  {
    label: 'Dispoziční čas',
    value: 'availability',
  },
  {
    label: 'Harmonogram',
    value: 'timetable',
  },
  {
    label: 'Klientské preference',
    value: 'preferences',
  },
];

export const EmployeeLayout = (): JSX.Element => {
  const { employeeId } = useParams<{ employeeId: string }>();

  const { data: employee } = useSWR<EmployeeDetailed>(
    `/employees/${employeeId}`,
    getFetcher
  );

  const [fullname, setFullname] = useState<string | undefined>(undefined);

  // Set the person's fullname when we got a client.
  useEffect(() => {
    if (!employee) return;
    setFullname(`${employee.firstName} ${employee.lastName}`);
  }, [employee]);

  return (
    <PersonLayout
      fullname={fullname}
      onClosePath="/employees"
      serviceDependentSections={[]}
      navigationOptions={navigationOptions}
      inputSection={undefined}
    />
  );
};
